import React from 'react';

export function PodGridContentItem(props: React.PropsWithChildren<any>) {

	return (
		<div className='pods-benefits-grid-item-value'>
			{props.children}
		</div>
	);
}
